/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';

/**
 * POST body discriminated by ``protocol``: dispatches to the correct per-protocol
 * create serializer. Validation and persistence are handled by the concrete serializer.
 * @export
 * @interface VoiceAgentInferencerCreatePolymorphicShared
 */
export interface VoiceAgentInferencerCreatePolymorphicShared {
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerCreatePolymorphicShared
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCreatePolymorphicShared
   */
  credentialValue?: string | null;
}

/**
 * Check if a given object implements the VoiceAgentInferencerCreatePolymorphicShared interface.
 */
export function instanceOfVoiceAgentInferencerCreatePolymorphicShared(
  value: object,
): value is VoiceAgentInferencerCreatePolymorphicShared {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerCreatePolymorphicSharedFromJSON(
  json: any,
): VoiceAgentInferencerCreatePolymorphicShared {
  return VoiceAgentInferencerCreatePolymorphicSharedFromJSONTyped(json, false);
}

export function VoiceAgentInferencerCreatePolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerCreatePolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
  };
}

export function VoiceAgentInferencerCreatePolymorphicSharedToJSON(
  value?: VoiceAgentInferencerCreatePolymorphicShared | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
  };
}
